<template>
  <div class="ui-dropzone">
    <vue-dropzone
      id="dropzone"
      ref="dropzone"
      class="ui-dropzone__area"
      :class="[{ 'ui-dropzone__area--error': error }, { 'ui-dropzone__area--disabled': disabled }]"
      :options="options"
      :useCustomSlot="showCustomSlot"
      @vdropzone-file-added="handleFileAdded"
      @vdropzone-removed-file="handleFileRemoved"
    >
      <div v-if="showCustomSlot" class="ui-dropzone__custom-slot">
        <slot></slot>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'Dropzone',
  emits: ['input', 'change', 'file-added', 'file-removed'],
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    options: {
      type: Object,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCustomSlot: false,
    }
  },
  created() {
    if (this.$slots.default) this.showCustomSlot = true
  },
  methods: {
    getAcceptedFiles() {
      if (!this.$refs.dropzone) return []

      return this.$refs.dropzone.getAcceptedFiles()
    },
    syncFiles(files) {
      this.$emit('input', files)
      this.$emit('change', files)
    },
    handleFileAdded(file) {
      const files = this.getAcceptedFiles()

      this.showCustomSlot = false

      this.syncFiles([...files, file])

      this.$emit('file-added', file)
    },
    handleFileRemoved(file) {
      const files = this.getAcceptedFiles()

      this.showCustomSlot = !files.length

      this.syncFiles(files)

      this.$emit('file-removed', file)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.ui-dropzone
  .vue-dropzone.ui-dropzone__area
    margin-top: 0 !important
    padding: 12px
    border: 2px dashed var(--field-border-color, #c0c0cc)
    background: transparent
    border-radius: 6px
    min-height: auto
    z-index: 1
    position: relative
    letter-spacing: .2px
    color: #777
    transition: .2s linear

    &--error
      border: 2px dashed var(--field-error-border-color, $error) !important

    &--disabled
      opacity: var(--field-opacity-disabled, 0.7)
      pointer-events: none
      background-color: var(--field-disabled-bg-color, #ededed)

    &:hover
      background-color: var(--field-dropdown-hover, #00a2ae)
      .ui-dropzone__custom-slot
        color: #ffffff

  &__custom-slot
    max-width: 65%
    margin: 30px auto
    color: var(--field-placeholder-color, $gray-text)
    font-size: 16px
    line-height: 1.4
    display: flex
    align-items: center
    justify-content: center
    opacity: .75

  &__files
    margin-top: 12px

  &__file
    font-size: 14px
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/Dropzone.vue